// @flow
import * as React from 'react';
import { Col, Glyphicon } from 'react-bootstrap';
import { HelpPlay } from './Icons';
import VideoModal from '../components/VideoModal';

type Props = {
  pdfUrl?: string,
  videoUrl?: string,
  extraClass?: string
};

type State = {
  showModal: boolean
};

class HelpWrapper extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  openModal = () => {
    this.setState({
      showModal: true
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false
    });
  };

  render() {
    const { pdfUrl, videoUrl, extraClass = '' } = this.props;
    return (
      <div>
        {pdfUrl &&
          videoUrl && (
            <Col
              sm={12}
              className={'help-wrapper help-two-lines ' + extraClass}
            >
              <a
                className="help-link"
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Glyphicon glyph="question-sign" aria-hidden="true" />
                <span className="sr-only">
                  Download unaddressed mail service guide(PDF)
                </span>
              </a>
              <button
                className="help-link"
                onClick={this.openModal}
                target="_blank"
                rel="noopener noreferrer"
                style={{ position: 'relative', top: '1px' }}
              >
                <HelpPlay width="18" height="18" />
                <span className="sr-only">
                  Open video – Guide to using the Unaddressed Mail booking
                  system
                </span>
              </button>
              <br />
              <span className="red-help-text">Help</span>
              <VideoModal
                showModal={this.state.showModal}
                close={this.closeModal}
                videoUrl={videoUrl}
                title="Help"
              />
            </Col>
          )}
        {pdfUrl &&
          !videoUrl && (
            <Col sm={12} className={'help-wrapper ' + extraClass}>
              <Glyphicon glyph="question-sign" aria-hidden="true" />
              <span className="sr-only">
                Download unaddressed mail service guide(PDF)
              </span>
              <a
                className="help-link"
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="red-help-text">Help</span>
              </a>
            </Col>
          )}
        {videoUrl &&
          !pdfUrl && (
            <Col sm={12} className={'help-wrapper ' + extraClass}>
              <button
                className="help-link"
                onClick={this.openModal}
                target="_blank"
                rel="noopener noreferrer"
                style={{ position: 'relative', top: '1px' }}
              >
                <HelpPlay width="18" height="18" />
                <span className="sr-only">
                  Open video – Guide to using the Unaddressed Mail booking
                  system
                </span>
                <span className="red-help-text"> Help</span>
              </button>
              <VideoModal
                showModal={this.state.showModal}
                close={this.closeModal}
                videoUrl={videoUrl}
                title="Help"
              />
            </Col>
          )}
      </div>
    );
  }
}

export default HelpWrapper;



// WEBPACK FOOTER //
// ./src/components/HelpWrapper.js